import { type ReactNode, useMemo, useSyncExternalStore } from 'react';
import { I18nextProvider } from 'react-i18next';
import { getLocale, setLocale, subscribeLocale } from './browser';
import { createTranslator, getDirection, webI18n } from './index';
export const useLocale = () =>
  useSyncExternalStore(subscribeLocale, getLocale, () => 'en' as const);
export const useTranslation = () => {
  const locale = useLocale();
  return useMemo(
    () => ({ locale, direction: getDirection(locale), setLocale, t: createTranslator(locale) }),
    [locale],
  );
};
export const I18nProvider = ({ children }: { children: ReactNode }) => (
  <I18nextProvider i18n={webI18n}>{children}</I18nextProvider>
);
